export const ADD_PAGE = 'ADD_PAGE';
export const ADD_VISUALISATION = 'ADD_VISUALISATION';
